/**
 * Semantic mapping of game props to actual atlas frames
 * Used to replace placeholders with high-res generated assets
 *
 * NOTE: The 'legal_items' atlas was removed. Using 'legal_items_high_res' instead.
 * Frame names are numbered (legal_items_high_res_0001 through 0041).
 * TODO: Create a proper mapping of frame numbers to item names once sprites are reviewed.
 */

import { WORLD_TILES } from './tileIndex';

export interface AssetMapping {
  atlas: string;
  frame: string;
  scale?: number;
  yOffset?: number; // Visual adjustment
}

// Map logical prop keys to their physical asset frames
// Using numbered frames from legal_items_high_res atlas
export const PROPS_MAPPING: Record<string, AssetMapping> = {
  // Books (using numbered frames - exact mapping TBD)
  'law_book_red': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0001', scale: 0.6 },
  'law_book_blue': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0002', scale: 0.6 },
  'books_stack': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0003', scale: 0.6 },
  'citation_book': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0004', scale: 0.6 },
  'statute_book': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0005', scale: 0.6 },

  // Tools
  'gavel': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0006', scale: 0.6 },
  'scales': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0007', scale: 0.6 },
  'magnifying_glass': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0008', scale: 0.6 },
  'flashlight': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0009', scale: 0.6 },

  // Documents
  'legal_brief': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0010', scale: 0.6 },
  'subpoena': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0012', scale: 0.6 },
  'contract_scroll': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0013', scale: 0.6 },
  'redlined_doc': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0014', scale: 0.6 },
  'exhibit_tag_A': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0015', scale: 0.6 },

  // Office
  'briefcase': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0016', scale: 0.6 },
  'coffee': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0017', scale: 0.6 },
  'stapler': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0018', scale: 0.6 },
  'ink_bottle': { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0019', scale: 0.6 },
};

// Override specific Oryx tile IDs with new assets
export const TILE_OVERRIDES: Record<number, AssetMapping> = {
  // Map BOOKSHELF_B (used as scroll placeholder) to an actual scroll/doc
  [WORLD_TILES.BOOKSHELF_B]: { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0013', scale: 0.5 },

  // Map SIGN to Exhibit Tag
  [WORLD_TILES.SIGN]: { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0015', scale: 0.5 },

  // Map ORB to Scales
  [WORLD_TILES.ORB]: { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0007', scale: 0.5 },

  // Map CRYSTAL to Gavel
  [WORLD_TILES.CRYSTAL]: { atlas: 'legal_items_high_res', frame: 'legal_items_high_res_0006', scale: 0.5 },
};
